import React from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import AppLayout from "./AppLayout"
import "../shared/styles/system.css"

import { AuthProvider } from "../context/AuthContext"
import ProtectedRoute from "./ProtectedRoute"

import LoginPage from "../pages/LoginPage"
import AcceptInvitationPage from "../pages/AcceptInvitationPage"

import DashboardPro from "../features/dashboard/pages/DashboardPro"
import PatientsPage from "../features/patients/pages/PatientsPage"
import AgendaPro from "../features/agenda/pages/AgendaPro"
import IntelligentCenter from "../pages/IntelligentCenter"

import DoctorPermissionsAdmin from "../settings/DoctorPermissionsAdmin"
import TreatmentRulesAdmin from "../settings/TreatmentRulesAdmin"
import DoctorTreatmentMatrix from "../settings/DoctorTreatmentMatrix"

import CashClosingPage from "../pages/CashClosingPage"
import FinancialExecutivePage from "../pages/FinancialExecutivePage"
import BillingPage from "../pages/BillingPage"
import ClinicalHistoryPage from "../pages/ClinicalHistoryPage"
import OdontogramMappingsPage from "../pages/OdontogramMappingsPage"
import TreatmentCatalogPage from "../pages/TreatmentCatalogPage"
import TreatmentPlansPage from "../features/treatment-plans/pages/TreatmentPlansClinicPage"
import TreatmentPlanDetailPage from "../features/treatment-plans/pages/TreatmentPlanWorkspacePage"

import ChairsPage from "../features/chairs/pages/ChairsPage"
import DoctorsPage from "../features/doctors/pages/DoctorsPage"
import UsersPage from "../features/users/pages/UsersPage"
import UpgradePlanPage from "../features/subscriptions/pages/UpgradePlanPage"
import ClinicsPage from "../features/clinics/pages/ClinicsPage"
import RegisterPage from "../pages/RegisterPage"
import SettingsHomePage from "../pages/SettingsHomePage"
import SettingsPage from "../pages/SettingsPage"
import SubscriptionAdminPage from "../features/subscriptions/pages/SubscriptionAdminPage"
import PublicClinicalIntakePage from "../pages/PublicClinicalIntakePage"
import ClinicResourcesPage from "../pages/settings/ClinicResourcesPage"
import TeamAccessPage from "../pages/settings/TeamAccessPage"
import ScheduleAvailabilityPage from "../pages/settings/ScheduleAvailabilityPage"
import TreatmentsPermissionsPage from "../pages/settings/TreatmentsPermissionsPage"
import ClinicalEnginePage from "../pages/settings/ClinicalEnginePage"
import SystemAccountPage from "../pages/settings/SystemAccountPage"
import VerifyEmailPage from "../pages/VerifyEmailPage"

export default function AppRoutes() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* RUTAS PÚBLICAS */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/invite" element={<AcceptInvitationPage />} />
          <Route
            path="/clinical-history/public/intake/:token"
            element={<PublicClinicalIntakePage />}
          />

          {/* RUTAS PRIVADAS */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/agenda" replace />} />

            {/* CORE */}
            <Route path="/dashboard" element={<DashboardPro />} />
            <Route path="/agenda" element={<AgendaPro />} />
            <Route path="/patients" element={<PatientsPage />} />
            <Route path="/patients/:id" element={<PatientsPage />} />

            {/* CLÍNICA */}
            <Route path="/treatment-plans" element={<TreatmentPlansPage />} />
            <Route path="/treatment-plans/:id" element={<TreatmentPlanDetailPage />} />
            <Route path="/clinical-history" element={<ClinicalHistoryPage />} />

            {/* FINANZAS */}
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/cash-closing" element={<CashClosingPage />} />
            <Route path="/financial-executive" element={<FinancialExecutivePage />} />

            {/* IA */}
            <Route path="/ia" element={<IntelligentCenter />} />

            {/* CONFIGURACIÓN — PORTADA NUEVA */}
            <Route path="/settings" element={<SettingsHomePage />} />

            {/* CONFIGURACIÓN — RUTAS NUEVAS OFICIALES */}
            <Route path="/settings/clinic-resources" element={<ClinicResourcesPage />} />
            <Route path="/settings/team-access" element={<TeamAccessPage />} />
            <Route path="/settings/schedule-availability" element={<ScheduleAvailabilityPage />} />
            <Route path="/settings/treatments-permissions" element={<TreatmentsPermissionsPage />} />
            <Route path="/settings/clinical-engine" element={<ClinicalEnginePage />} />
            <Route path="/settings/system-account" element={<SystemAccountPage />} />

            {/* CONFIGURACIÓN — RUTAS ACTUALES VIVAS */}
            <Route path="/settings/clinics" element={<ClinicsPage />} />
            <Route path="/settings/chairs" element={<ChairsPage />} />
            <Route path="/settings/doctors" element={<DoctorsPage />} />
            <Route path="/settings/users" element={<UsersPage />} />
            <Route path="/settings/permissions" element={<DoctorPermissionsAdmin />} />
            <Route path="/settings/rules" element={<TreatmentRulesAdmin />} />
            <Route path="/settings/matrix" element={<DoctorTreatmentMatrix />} />
            <Route path="/settings/treatments" element={<TreatmentCatalogPage />} />
            <Route path="/settings/odontogram" element={<OdontogramMappingsPage />} />
            <Route path="/settings/subscription" element={<UpgradePlanPage />} />
            <Route
              path="/settings/subscriptions-admin"
              element={<SubscriptionAdminPage />}
            />
            <Route path="/settings/general" element={<SettingsPage />} />

            {/* AUXILIARES */}
            <Route path="/reports" element={<div style={{ padding: 24 }}>Reportes</div>} />

            {/* COMPATIBILIDAD CON RUTAS ANTERIORES */}
            <Route
              path="/clinics"
              element={<Navigate to="/settings/clinic-resources?tab=sedes" replace />}
            />
            <Route
              path="/chairs"
              element={<Navigate to="/settings/clinic-resources?tab=sillas" replace />}
            />
            <Route
              path="/doctors"
              element={<Navigate to="/settings/team-access?tab=doctors" replace />}
            />
            <Route
              path="/users"
              element={<Navigate to="/settings/team-access?tab=users" replace />}
            />

            <Route path="/config" element={<Navigate to="/settings" replace />} />

            <Route
              path="/rules"
              element={<Navigate to="/settings/clinical-engine?tab=rules" replace />}
            />
            <Route
              path="/matrix"
              element={<Navigate to="/settings/clinical-engine?tab=matrix" replace />}
            />
            <Route
              path="/odontogram-mappings"
              element={<Navigate to="/settings/clinical-engine?tab=odontogram" replace />}
            />

            <Route
              path="/treatment-catalog"
              element={<Navigate to="/settings/treatments-permissions?tab=catalog" replace />}
            />

            <Route
              path="/upgrade-plan"
              element={<Navigate to="/settings/system-account?tab=plan" replace />}
            />
            <Route
              path="/subscriptions-admin"
              element={<Navigate to="/settings/system-account?tab=subscriptions" replace />}
            />
            <Route
              path="/config/subscriptions"
              element={<Navigate to="/settings/system-account?tab=subscriptions" replace />}
            />

            <Route path="*" element={<Navigate to="/agenda" replace />} />
            
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}